export default __webpack_public_path__ + "static/media/icone.5de5a798.png";